const orderStatus = {
  CREATED: 'CREATED',
  CONFIRMED: 'CONFIRMED',
  PACKED: 'PACKED',
  SHIPPED: 'SHIPPED',
  ARRIVING: 'ARRIVING',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  DELIVERED: 'DELIVERED',
  READY_FOR_PICKUP_FROM_STORE: 'READY_FOR_PICKUP_FROM_STORE',
  DELIVERY_ATTEMPTED: 'DELIVERY_ATTEMPTED',
  DELIVERY_RESCHEDULED: 'DELIVERY_RESCHEDULED',
  SHIPMENT_CONFISCATED: 'SHIPMENT_CONFISCATED',
  SHIPMENT_DAMAGED: 'SHIPMENT_DAMAGED',
  SHIPMENT_ON_HOLD: 'SHIPMENT_ON_HOLD',
  SHIPMENT_PROBLEM: 'SHIPMENT_PROBLEM',
  SHIPMENT_DELAYED: 'SHIPMENT_DELAYED',
  DELIVERY_RESHCEDULED: 'DELIVERY_RESHCEDULED',
  'OUT FOR DELIVERY': 'OUT FOR DELIVERY',
  'DELIVERY ATTEMPTED': 'DELIVERY ATTEMPTED',
  RETURN_INITIATED: 'RETURN_INITIATED',
  REFUND_INITIATED: 'REFUND_INITIATED',
  PARTIALLY_REFUND_INITIATED: 'PARTIALLY_REFUND_INITIATED',
  PARTIALLY_RETURN_INITIATED: 'PARTIALLY_RETURN_INITIATED',
  PARTIALLY_RETURNED: 'PARTIALLY_RETURNED',
  PARTIALLY_REFUND: 'PARTIALLY_REFUND',
  PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
  PARTIALLY_SHIPPED: 'PARTIALLY_SHIPPED',
  PARTIALLY_PACKED: 'PARTIALLY_PACKED',
  PARTIALLY_CANCELED: 'PARTIALLY_CANCELLED',
  AWAITING_STORE_CONFIRMATION: 'AWAITING_STORE_CONFIRMATION',
  CANCELLED: 'CANCELLED',
  'DELIVERY DELAYED': 'DELIVERY DELAYED',
  'RETURN CANCELLED': 'RETURN CANCELLED'
};

const deliveryMethod = {
  RUSH: 'RUSH',
  PRIORITY: 'PRIORITY',
  STANDARD: 'STANDARD'
}

const trackingOrderList = [
  orderStatus.CREATED,
  orderStatus.CONFIRMED,
  orderStatus.PACKED,
  orderStatus.SHIPPED,
  orderStatus.ARRIVING,
  orderStatus.OUT_FOR_DELIVERY,
  orderStatus.DELIVERED,
  orderStatus.READY_FOR_PICKUP_FROM_STORE
];

const markAsReceivedStatusList = [
  orderStatus.SHIPPED,
  orderStatus.OUT_FOR_DELIVERY,
  orderStatus.DELIVERY_ATTEMPTED,
  orderStatus.SHIPMENT_CONFISCATED,
  orderStatus.SHIPMENT_DAMAGED,
  orderStatus.SHIPMENT_PROBLEM,
  orderStatus.SHIPMENT_DELAYED,
  orderStatus.DELIVERY_RESHCEDULED
];

const cancellableStatusList = [
  orderStatus.CREATED,
  orderStatus.CONFIRMED,
  orderStatus.PARTIALLY_CANCELED,
  orderStatus.PACKED,
  orderStatus.SHIPPED,
  orderStatus['OUT FOR DELIVERY'],
  orderStatus.OUT_FOR_DELIVERY,
  orderStatus['DELIVERY DELAYED'],
  orderStatus.ARRIVING
];

const cancelItemPopupList = [
  orderStatus.PACKED,
  orderStatus.SHIPPED,
  orderStatus['OUT FOR DELIVERY'],
  orderStatus.OUT_FOR_DELIVERY,
  orderStatus['DELIVERY DELAYED'],
  orderStatus.ARRIVING
];

const statusWithPaymentDisplayEnabled = [
  orderStatus.CONFIRMED,
  orderStatus.CREATED,
  orderStatus.CANCELLED,
  orderStatus.PACKED,
  orderStatus.SHIPPED,
  orderStatus.DELIVERED,
  orderStatus.SHIPMENT_DELAYED,
  orderStatus.DELIVERY_ATTEMPTED,
  orderStatus['DELIVERY ATTEMPTED'],
  orderStatus.DELIVERY_RESHCEDULED,
  orderStatus.OUT_FOR_DELIVERY,
  orderStatus['OUT FOR DELIVERY'],
  orderStatus.AWAITING_STORE_CONFIRMATION,
  orderStatus.READY_FOR_PICKUP_FROM_STORE,
  orderStatus['RETURN CANCELLED'],
  orderStatus.PARTIALLY_DELIVERED,
  orderStatus.PARTIALLY_SHIPPED,
  orderStatus.PARTIALLY_PACKED,
  orderStatus.DELIVERY_RESCHEDULED,
  orderStatus.SHIPMENT_CONFISCATED,
  orderStatus.SHIPMENT_DAMAGED,
  orderStatus.SHIPMENT_ON_HOLD,
  orderStatus.SHIPMENT_PROBLEM
];

const downloadInvoiceEnableBtnStatusList = [
  orderStatus.DELIVERED,
  orderStatus.RETURN_INITIATED,
  orderStatus.REFUND_INITIATED,
  orderStatus.PARTIALLY_REFUND_INITIATED,
  orderStatus.PARTIALLY_RETURN_INITIATED,
  orderStatus.PARTIALLY_RETURNED,
  orderStatus.PARTIALLY_REFUND
];
const reOrderableStatusList = [orderStatus.CANCELLED];

export {
  orderStatus,
  deliveryMethod,
  trackingOrderList,
  markAsReceivedStatusList,
  cancellableStatusList,
  cancelItemPopupList,
  reOrderableStatusList,
  statusWithPaymentDisplayEnabled,
  downloadInvoiceEnableBtnStatusList
};
